import { TableCell, TableHead, TableRow } from "@mui/material";

const ClaimColumns = [
  {
    key: "sr_no",
    column_name: "Sr No.",
    style: {
      fontSize: ".9rem",
      width: "3%",
    },
  },
  {
    key: "stockists_master_id",
    column_name: "AushadhAI No.",
    style: {
      fontSize: ".9rem",
      width: "5%",
    },
  },
  {
    key: "po_number",
    column_name: "Po. No.",
    style: {
      fontSize: ".9rem",
      width: "5%",
    },
  },
  {
    key: "party_name",
    column_name: "Party Name",
    style: {
      fontSize: ".9rem",
      width: "10%",
    },
  },
  {
    key: "party_code",
    column_name: "Party Code",
    style: {
      fontSize: ".9rem",
      width: "7%",
    },
  },
  {
    key: "status",
    column_name: "Status",
    style: {
      fontSize: ".9rem",
      width: "3%",
    },
  },
  {
    key: "orders",
    column_name: "Orders",
    style: {
      fontSize: ".9rem",
      width: "5%",
    },
  },
  {
    key: "lr_no",
    column_name: "LR No.",
    style: {
      fontSize: ".9rem",
      width: "7%",
    },
  },
  {
    key: "lr_date",
    column_name: "LR DT",
    style: {
      fontSize: ".9rem",
      width: "9%",
    },
  },
  {
    key: "ref_no",
    column_name: "Claim No.",
    style: {
      fontSize: ".9rem",
      width: "8.3%",
    },
  },
  {
    key: "ref_date",
    column_name: "Claim Date",
    style: {
      fontSize: ".9rem",
      width: "8.3%",
    },
  },
  {
    key: "received_date",
    column_name: "Received Date",
    style: {
      fontSize: ".9rem",
      width: "7%",
    },
  },
  {
    key: "created_on",
    column_name: "Created At",
    style: {
      fontSize: ".9rem",
      width: "7%",
    },
  },
  {
    key: "created_by",
    column_name: "Created By",
    style: {
      fontSize: ".9rem",
      width: "5%",
    },
  },
  {
    key: "action",
    column_name: "Actions",
    style: {
      fontSize: ".9rem",
      width: "15%",
    },
  },
];

const ColumnHeader = () => {
  return (
    <TableHead>
      <TableRow>
        {ClaimColumns.map((column) => (
          <TableCell
            style={{
              fontSize: "0.75em",
              padding: "0.4em",
              textAlign: "center",
              color: "#ffffff",
              backgroundColor: "#000000",
              fontFamily: "Montserrat",
              ...column.style,
            }}
            key={column.key}
          >
            {column.column_name}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export { ClaimColumns, ColumnHeader };
